import PropTypes from "prop-types";
import React from "react";

export const Plus = (props) => {
  const { className, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <path strokeWidth={6} d="M 0 16 H 32" />
      <path strokeWidth={6} d="M 16 0 V 32" />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      style,
      viewBox: "0 0 32 32",
    };
  }
};

Plus.displayName = "PlusIcon";

Plus.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /**
   * custom allows for component to implement styling for a specific characteristic. There is no obligation for a
   * component to implement the custom prop.
   */
  custom: PropTypes.object,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

Plus.defaultProps = {
  "aria-label":
    "Plus" /* Will use icon name as default, but change if needed and ensure name is lowercase. */,
  role: "img",
};
